module.exports = __webpack_public_path__ + "static/media/ic-service-large.cf5f8d44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-service-large.svg
// module id = 663
// module chunks = 14